import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partnership_program: {
        trackers: {
          header: 'HEADER',
          download_report: 'DOWNLOAD_REPORT',
          aasm_state: {
            assigned: 'AASM_STATE_ASSIGNED',
          },
        },
      },
    },
  }));
}
